import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ArrowRight, Calendar, Clock, ArrowUpDown } from "lucide-react";
import blogsData from "../../data/blogs.json";
import "./Blog.css";

export default function BlogList() {
  const [sortBy, setSortBy] = useState('newest');

  const sortedBlogs = [...blogsData].sort((a, b) => {
    if (sortBy === 'newest') return new Date(b.date) - new Date(a.date);
    if (sortBy === 'oldest') return new Date(a.date) - new Date(b.date);
    if (sortBy === 'readingTimeAsc') return parseInt(a.readTime) - parseInt(b.readTime);
    if (sortBy === 'readingTimeDesc') return parseInt(b.readTime) - parseInt(a.readTime);
    return 0;
  });

  return (
    <div className="blog-container">
      <Helmet>
        <title>Technical Blog | Raj Pawan Shukla</title>
        <meta name="description" content="Thoughts, tutorials, and insights on software development, Magento 2, Docker, and React by Raj Pawan Shukla." />
        <meta property="og:title" content="Technical Blog | Raj Pawan Shukla" />
        <meta property="og:description" content="Thoughts, tutorials, and insights on software development, Magento 2, Docker, and React by Raj Pawan Shukla." />
      </Helmet>
      <div className="blog-header">
        <h1>Technical Blog</h1>
        <p>Thoughts, tutorials, and insights on software development.</p>
      </div>
      
      <div className="blog-controls" style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '20px' }}>
        <div className="sort-container" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <ArrowUpDown size={16} color="var(--text-secondary, #888)" />
          <select 
            value={sortBy} 
            onChange={(e) => setSortBy(e.target.value)}
            style={{
              padding: '8px 12px',
              borderRadius: '8px',
              border: '1px solid var(--border-color, #333)',
              backgroundColor: 'var(--bg-secondary, #1a1a2e)',
              color: 'var(--text-primary, #fff)',
              cursor: 'pointer',
              outline: 'none',
              fontFamily: 'inherit',
              fontSize: '0.9rem'
            }}
          >
            <option value="newest">Newest First</option>
            <option value="oldest">Oldest First</option>
            <option value="readingTimeAsc">Reading Time (Short to Long)</option>
            <option value="readingTimeDesc">Reading Time (Long to Short)</option>
          </select>
        </div>
      </div>
      
      <div className="blog-grid">
        {sortedBlogs.map((blog) => (
          <Link to={`/blogs/${blog.slug}`} key={blog.slug} className="blog-card">
            <h2 className="blog-title">{blog.title}</h2>
            <div className="blog-meta">
              <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <Calendar size={14} /> {blog.date}
              </span>
              <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <Clock size={14} /> {blog.readTime}
              </span>
            </div>
            <p className="blog-excerpt">{blog.excerpt}</p>
            <span className="blog-read-more">
              Read Article <ArrowRight size={16} />
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
